<template>
    <div class="delete-user text-error" @click="deleteUser()">
        Supprimer définitivement
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.component('delete-user', {
    props: {
        userId: {
            default: () => 0
        }
    },
    data() {
        return {
        }
    },
    mounted: function() {
    },
    methods: {
        deleteUser() {
            this.$swal({
                type: 'warning',
                title: 'Supprimer',
                html: 'Veuillez entrer le terme "<b>effacer</b>" pour confirmer la suppression <b>définitive</b> de l\'utilisateur.',
                input: 'text',
                showCancelButton: true,
                confirmButtonClass: 'PCR-swal-btn el-button--danger',
                confirmButtonText: 'Supprimer',
                cancelButtonText: 'Annuler',
                preConfirm: function (inputValue) {
                    return new Promise(function (resolve, reject) {
                        if (inputValue.toLowerCase() === 'effacer') {
                            resolve();
                        } else {
                            reject('Valeur incorrecte');
                        }
                    });
                }
            }).then(() => {
                this.$http.delete(`/api/system/user/${this.userId}`)
                    .then((response) => {
                        this.$defaultSwalApiResponse(response, () => {
                            this.$swal({
                                type: 'success',
                                title: 'Supprimé !',
                                text: 'L\'utilisateur a bien été supprimé.'
                            }).then(() => {});
                            this.$emit('on-remove');
                        });
                    }, this.$defaultSwalApiResponse );
            });
        }
    },
    watch: {
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/cross-components/delete-user.vue